<template>
  <v-container fluid class="d-flex flex-wrap">
    <p class="align-center text-center center justify-center center"> {{ $t('dash.statistics.showForDates' )}}</p>
    <div class="d-flex flex-row align-center text-center center justify-center">
      <div>
        <v-menu
          ref="startDateMenu"
          v-model="startDateMenu"
          :close-on-content-click="false"
          prepend-icon="mdi-calendar"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              :label="$t('dash.statistics.startDate')"
              prepend-icon="fa-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            no-title
            :max="endDate"
            scrollable
            @input="startDateMenu = false"
          >
          </v-date-picker>
        </v-menu>
      </div>
      <div>
        <v-menu
          ref="endDateMenu"
          v-model="endDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              :label="$t('dash.statistics.endDate')"
              prepend-icon="fa-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            no-title
            :min="startDate"
            :max="$moment().format('yyyy-MM-DD')"
            scrollable
            @input="endDateMenu = false"
          >
          </v-date-picker>
        </v-menu>
      </div>
      <v-btn
        class="ml-3 primary"
        @click.prevent="generateStatistics()">{{ $t("dash.statistics.generate") }}</v-btn>
    </div>
    <v-expansion-panels accordion class="ma-10">
      <v-expansion-panel>
        <v-expansion-panel-header><b>{{ $t("dash.statistics.currentOccupation") }} <small class="ml-2"><i>* {{ $t("dash.statistics.unaffectedByDates") }}</i></small></b></v-expansion-panel-header>
        <v-expansion-panel-content class="justify-start text-start">
          <p>{{ $t("dash.statistics.currentOccupation") }}: {{currentOccupationsTotal}}</p>
          <p>{{ $t("dash.statistics.babiesActiveUse") }}: {{currentActiveParents}}</p>
          <p class="ml-6" v-for="item in currentOccupations" :key="item.days">
            {{ $t('dash.statistics.babyAmount' )}} {{item.days }} {{ $t('dash.statistics.layDays' )}}: {{ item.amount }}
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><b>{{ $t("dash.statistics.dismissalsDuringPeriod", {startDate: this.displayedStartDate, endDate: this.displayedEndDate}) }}</b></v-expansion-panel-header>
        <v-expansion-panel-content class="justify-start text-start">
          <p>{{ $t("dash.statistics.amountOfBabiesDismissedDuringPeriod") }}: {{dismissals.length}}</p>

<!--          <p class="ml-6" v-for="item in dismissals" :key="item.days">-->
<!--            {{ $t('dash.statistics.babyAmount' )}} {{item.days }} {{ $t('dash.statistics.layDays' )}}: {{ item.amount }}-->
<!--          </p>-->
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><b>{{ $t("dash.statistics.postsDataDuringPeriod", {startDate: this.displayedStartDate, endDate: this.displayedEndDate}) }}</b></v-expansion-panel-header>
        <v-expansion-panel-content class="justify-start text-start">
          <p>{{ $t("dash.statistics.totalAmountOfPosts") }}: {{ posts.length }}</p>
          <p class="ml-6">{{ $t("dash.statistics.totalAmountOfPostsByNurses") }}: {{ posts.filter(x => x.user.role === 'n' || x.user.role === 'a').length }}</p>
          <p class="ml-6">{{ $t("dash.statistics.totalAmountOfPostsByParents") }}: {{ posts.filter(x => x.user.role === 'p').length }}</p>
          <p class="ml-6">{{ $t("dash.statistics.totalAmountOfPostsWithReactions") }}: {{ posts.filter(x => x.likes || x.comments).length }}</p>
          <p class="ml-6">{{ $t("dash.statistics.totalAmountOfMilestonePosts") }}: {{ posts.filter(x => x.milestone).length }}</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><b>{{ $t("dash.statistics.pageViewsDuringPeriod", {startDate: this.displayedStartDate, endDate: this.displayedEndDate}) }}</b></v-expansion-panel-header>
        <v-expansion-panel-content class="justify-start text-start">
          <p v-for="(pageView, ndx) in pageViews" :key="ndx">{{ $t("dash.statistics.totalAmountOfViewsForPage") }} "{{ pageView.pageName }} {{pageView.parameter}}": {{pageView.count}}</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import {neoparentPosts, neoparentPatients, hospitalHistory} from "@/api";

export default {
  name: "neoparent-statistics",
  data() {
    return {
      currentOccupations: [],
      dismissals: [],
      startDate: '',
      endDate: '',
      displayedStartDate: '',
      displayedEndDate: '',
      startDateMenu: false,
      endDateMenu: false,
      posts: [],
      pageViews: []
    };
  },
  mounted() {
    this.startDate = this.$moment().subtract(1, 'days').subtract(1, 'months').format('yyyy-MM-DD')
    this.endDate = this.$moment().subtract(1, 'days').format('yyyy-MM-DD')

    this.displayedStartDate = this.startDate
    this.displayedEndDate = this.endDate

    this.getPatients()
    this.generateStatistics()
    this.getPageViews()
  },
  computed: {
    currentOccupationsTotal() {
      let amount = 0;
      this.currentOccupations.forEach(x => {
        amount = amount + x.amount
      })

      return amount
    },
    currentActiveParents() {
      if (!this.patients) {
        return 0;
      }
      return this.patients.filter(x => x.hasParents).length;
    }
  },
  methods: {
    generateStatistics() {
      this.getDismissalHistory()
      this.getAllPostsForHospital()
      this.getPageViews()

      this.displayedStartDate = this.startDate
      this.displayedEndDate = this.endDate
    },
    getPatients() {
      const that = this
      neoparentPatients
        .getAllPatientsForHospital(this.$store.getters.user.hospital.id)
        .then(result => {
          const patients = result.data.patients
            .filter(p => !p.isArchived && !p.isDeceased)
            .sort((a, b) => a.firstName.localeCompare(b.firstName));

           patients.forEach(patient => {
             const occupationDays = this.$moment().diff(patient.createdAt, 'days')

             const occupationDaysItemIndex = that.currentOccupations.findIndex(x => x.days === occupationDays)
             if (occupationDaysItemIndex !== -1) {
               that.currentOccupations[occupationDaysItemIndex].amount = that.currentOccupations[occupationDaysItemIndex].amount + 1
             } else {
               that.currentOccupations.push({
                 "days": occupationDays,
                 "amount": 1
               })
             }
          })

        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    getDismissalHistory() {
      const that = this
      hospitalHistory
        .getDismissalHistoryList(that.startDate, that.endDate)
        .then(result => {
          const dismissalHistory = result.data.dismissalHistory
            .filter(x => !x.dismissalUndone);

          dismissalHistory.forEach(dismissal => {
             const occupationDays = dismissal.amountOfLayDays

             const occupationDaysItemIndex = that.dismissals.findIndex(x => x.days === occupationDays)
             if (occupationDaysItemIndex !== -1) {
               that.dismissals[occupationDaysItemIndex].amount = that.dismissals[occupationDaysItemIndex].amount + 1
             } else {
               that.dismissals.push({
                 "days": occupationDays,
                 "amount": 1
               })
             }
          })
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    getAllPostsForHospital() {
      const that = this
      neoparentPosts.getAllForHospital(that.startDate, that.endDate)
        .then((res) => {
          that.posts = res.data.posts.filter(x => !x.isDraft)
        })
    },
    getPageViews() {
      const that = this
      hospitalHistory
        .getPageHistory(that.startDate, that.endDate)
        .then((res) => {
          that.pageViews = res.data.events
        })
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 50px;
}
</style>
